import { Navigate, useParams } from 'react-router';

export function ContentEditRedirect() {
  const { contentId, courseId } = useParams();

  if (!courseId || !contentId) {
    return <Navigate replace to="/app/courses" />;
  }

  return (
    <Navigate
      replace
      to={`/app/courses/${courseId}/${contentId}?edit=1`}
    />
  );
}
